<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newPublicApiAccess()"
                aria-label="Add public API access key"
                *appIsGranted="['Public API access', 'CREATE']"
        >
            {{'Add public API access key'|translate}}
        </button>
    </div>

    <div class="nav material2">
        <div class="nav-item">

        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
